(function initHeaderSearchRecent() {
    'use strict';

    const STORAGE_KEY = 'shasa_recent_searches';
    const MAX_SEARCHES = 5;

    const SELECTORS = {
        searchPopdown: 'header-search-popdown',
        form: '.search-form',
        input: 'input[type="search"]',

        recentContainer: '[data-recent-searches]',
        clearButton: '[data-recent-searches-clear]',
    };

    const RECENT_ICON = `
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M6.5 2.7627V6.50019L8.9375 8.12519"
        stroke="currentColor"
        stroke-width="1.1375"
        stroke-linecap="round"
      />
      <path
        d="M1.94998 6.50011C1.94646 7.5505 2.30648 8.56975 2.96893 9.3849C3.63139 10.2001 4.55547 10.7609 5.58438 10.9723C6.61328 11.1836 7.68363 11.0325 8.61378 10.5445C9.54394 10.0565 10.2766 9.26174 10.6875 8.29503C11.0983 7.32832 11.162 6.24924 10.8678 5.24089C10.5736 4.23255 9.93958 3.35705 9.07333 2.76297C8.20707 2.1689 7.16196 1.89283 6.11533 1.98162C5.06869 2.07042 4.08502 2.5186 3.33123 3.25011"
        stroke="currentColor"
        stroke-width="1.1375"
      />
      <path
        d="M1.625 1.9502V4.5502H4.225"
        stroke="currentColor"
        stroke-width="1.1375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `;

    function normalizeSearchTerm(value) {
        return String(value || '')
            .trim()
            .replace(/\s+/g, ' ');
    }

    function getRecentSearches() {
        try {
            const storedValue =
                window.localStorage.getItem(
                    STORAGE_KEY
                );

            if (!storedValue) {
                return [];
            }

            const parsedValue =
                JSON.parse(storedValue);

            if (!Array.isArray(parsedValue)) {
                return [];
            }

            return parsedValue
                .map(normalizeSearchTerm)
                .filter(Boolean)
                .slice(0, MAX_SEARCHES);
        } catch (error) {
            console.warn(
                '[HeaderSearch] No fue posible leer las búsquedas recientes.',
                error
            );

            return [];
        }
    }

    function saveRecentSearches(searches) {
        try {
            window.localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(
                    searches.slice(0, MAX_SEARCHES)
                )
            );
        } catch (error) {
            console.warn(
                '[HeaderSearch] No fue posible guardar las búsquedas recientes.',
                error
            );
        }
    }

    function addRecentSearch(searchTerm) {
        const normalizedTerm =
            normalizeSearchTerm(searchTerm);

        if (!normalizedTerm) {
            return;
        }

        const currentSearches =
            getRecentSearches();

        const nextSearches = [
            normalizedTerm,
            ...currentSearches.filter(
                (item) =>
                    item.toLocaleLowerCase() !==
                    normalizedTerm.toLocaleLowerCase()
            ),
        ].slice(0, MAX_SEARCHES);

        saveRecentSearches(nextSearches);
        renderAllRecentSearches();
    }

    function clearRecentSearches() {
        try {
            window.localStorage.removeItem(
                STORAGE_KEY
            );
        } catch (error) {
            console.warn(
                '[HeaderSearch] No fue posible limpiar las búsquedas recientes.',
                error
            );
        }

        renderAllRecentSearches();
    }

    function createRecentSearchLink(term) {
        const link =
            document.createElement('a');

        link.className =
            'search-empty-state__link search-empty-state__link--recent';

        link.href =
            `${window.theme?.routes?.search_url || '/search'}?q=${encodeURIComponent(term)}`;

        const icon =
            document.createElement('span');

        icon.className =
            'search-empty-state__recent-icon';

        icon.innerHTML =
            RECENT_ICON;

        const text =
            document.createElement('span');

        text.textContent =
            term;

        link.append(
            icon,
            text
        );

        return link;
    }

    function renderRecentSearches(popdown) {
        if (!popdown) {
            return;
        }

        const container =
            popdown.querySelector(
                SELECTORS.recentContainer
            );

        const clearButton =
            popdown.querySelector(
                SELECTORS.clearButton
            );

        if (!container) {
            return;
        }

        const searches =
            getRecentSearches();

        container.replaceChildren();

        searches.forEach((term) => {
            container.appendChild(
                createRecentSearchLink(term)
            );
        });

        if (clearButton) {
            clearButton.hidden =
                searches.length === 0;
        }
    }

    function renderAllRecentSearches() {
        document
            .querySelectorAll(
                SELECTORS.searchPopdown
            )
            .forEach((popdown) => {
                renderRecentSearches(popdown);
            });
    }

    function bindSearchForm(popdown) {
        const form =
            popdown.querySelector(
                SELECTORS.form
            );

        const input =
            form?.querySelector(
                SELECTORS.input
            );

        if (!form || !input) {
            return;
        }

        form.addEventListener(
            'submit',
            () => {
                addRecentSearch(
                    input.value
                );
            }
        );
    }

    function bindClearButton(popdown) {
        const clearButton =
            popdown.querySelector(
                SELECTORS.clearButton
            );

        if (!clearButton) {
            return;
        }

        clearButton.addEventListener(
            'click',
            (event) => {
                event.preventDefault();

                clearRecentSearches();
            }
        );
    }

    function initPopdown(popdown) {
        if (
            !popdown ||
            popdown.dataset
                .recentSearchesInitialized ===
            'true'
        ) {
            return;
        }

        popdown.dataset
            .recentSearchesInitialized =
            'true';

        bindSearchForm(popdown);
        bindClearButton(popdown);
        renderRecentSearches(popdown);
    }

    function init() {
        document
            .querySelectorAll(
                SELECTORS.searchPopdown
            )
            .forEach(initPopdown);

        document.addEventListener(
            'nosto:header-search:submitted',
            (event) => {
                const query =
                    event.detail?.query;

                if (!query) {
                    return;
                }

                addRecentSearch(query);
            }
        );
    }

    document.addEventListener(
        'DOMContentLoaded',
        init
    );

    document.addEventListener(
        'shopify:section:load',
        init
    );
})();